import PropTypes from 'prop-types';
import download from 'downloadjs';
import BackLink from '../backLink';
import AuthFormLayout from '../authFormLayout';
import { ReactComponent as TonalityIcon } from '../../../assets/icons/tonality.svg';
import AUTHENTICATION_FIELDS from './fields';
import { TWO_FACTOR_AUTH } from '../../../utility/http';
import StorageService from '../../../utility/storageService';

const LoginAuthenticationFormLayout = props => {
  const {
    translations,
    submitForm,
    navigate,
    hasRecoveryCodes,
    recoveryCodes,
  } = props;
  const twoFactorAuth = JSON.parse(StorageService.get(TWO_FACTOR_AUTH));

  const onSubmit = e => {
    e.preventDefault();
    submitForm();
  };

  const handleDownload = async () => {
    const content = recoveryCodes?.join('\n');
    download(
      new Blob([content], {
        type: 'text/plain',
      }),
      `kadar-recovery-codes.txt`
    );
  };

  return (
    <AuthFormLayout
      {...props}
      handleSubmit={onSubmit}
      subtitleVariant="body1"
      icon={TonalityIcon}
      fields={AUTHENTICATION_FIELDS}
      handleDownload={handleDownload}
      hasRecoveryCodes={hasRecoveryCodes}
      showQRCode={twoFactorAuth?.initiate2FA}
      isAuthenticationView
    >
      <BackLink
        title={translations.backLabel}
        navigate={navigate}
        to="/login"
      />
    </AuthFormLayout>
  );
};

LoginAuthenticationFormLayout.propTypes = {
  translations: PropTypes.object.isRequired,
};

export default LoginAuthenticationFormLayout;
